module.exports = __webpack_public_path__ + "static/media/bone1_Bitmap_text.122e70d7.png";